<template>
	<!-- 站点档案 -->
	<div class="container">
		<!-- <div class="site-info" style="display: flex;margin-left: 20px;">
			<div class="site-info-item" style="">
				<div class="site-info-title">站点编码</div>
				<div class="site-info-num">{{siteDetail.mn}}</div>
			</div>
			<div class="site-info-item" style="">
				<div class="site-info-title">环保标准</div>
				<div class="site-info-num">{{siteDetail.standardOptionName}}</div>
			</div>
			<div class="site-info-item" style="">
				<div class="site-info-title">每天应上传数据</div>
				<div class="site-info-num">{{siteDetail.commSum}}</div>
			</div>
			<div class="site-info-item" style="">
				<div class="site-info-title">站点坐标</div>
				<div class="site-info-num">{{siteDetail.longitude}},{{siteDetail.latitude}}</div>
			</div>
		</div>
		<div style="width: 97%;
				height: 100px;
				border: 1px solid #199ed8;
				border-radius: 20px;
				display: flex;
				color: #fff;
				display: flex;
				margin-right: 10px;
				margin-left: 20px;
				margin-bottom: 20px;
				margin-top: 20px;">
			<div style="font-size: 15px;line-height: 100px;width: 10%;background: #199ed8;border-top-left-radius: 20px;border-bottom-left-radius: 20px;line-height: 100px;text-align: center;">站点介绍</div>
			<div style="width: 90%;text-indent: 2rem;padding: 5px;overflow: scroll;":class="siteDetail.remark?'':'none'">{{siteDetail.remark?siteDetail.remark:'暂无介绍'}}</div>
		</div> -->


		<!-- </div> -->
		<div class="site-info" style="display: flex;">
			<div class="site-info-border" style="">
				<div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-bianma" style="margin-right: 10px;"></div>站点编码</div>
				<div class="site-info-content" :title='siteDetail.mn'>{{siteDetail.mn}}</div>
			</div>
			<div class="site-info-border">
				<div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-huanbao1" style="margin-right: 10px;"></div>环保标准</div>
				<div class="site-info-content" style="font-family: 'UnidreamLED';font-size: 18px;white-space: pre-line;">{{siteDetail.standardOptionName}}</div>
			</div>
			<div class="site-info-border">
				<div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-icon--1" style="margin-right: 10px;font-size: 25px;padding-top: 1px;"></div>每天应上传数据</div>
				<div class="site-info-content" >{{siteDetail.commSum}}</div>
			</div>
			<div class="site-info-border">
				<div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-area" style="margin-right: 10px;"></div>站点坐标</div>
				<div class="site-info-content" style="flex-direction: column;"><div style="display: flex;flex-wrap: wrap;justify-content: center;"><div style="width: 70px">经度</div>{{siteDetail.longitude}}</div><div style="display: flex;flex-wrap: wrap;justify-content: center;"><div style="width: 70px">纬度</div>{{siteDetail.latitude}}</div></div>
			</div>
			<div class="site-info-border">
				<div style="font-size: 16px;color: #ccc;height: 50px;line-height: 50px;border-bottom: 3px solid #0c3784;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;display: flex;justify-content: center;"><div class="iconfont icon-jieshao" style="margin-right: 10px;"></div>站点介绍</div>
			<div style="width: 100%;height: 120px;color: #0ff;font-size: 16px;overflow: scroll;color: #0ff;text-indent:2rem;":class="siteDetail.remark?'':'none'">{{siteDetail.remark?siteDetail.remark:'暂无介绍'}}</div>
		</div>
	</div>
	<!-- <table style="width: 100%;color:#fff">
				<tbody>
					<tr>
						<td>站点编码</td>
						<td>{{siteDetail.mn}}</td>
						<td>环保标准</td>
						<td>{{siteDetail.standardOptionName}}</td>
						<td>站点坐标</td>
						<td>
							<div style="width:141px;text-align: center;">{{siteDetail.longitude}},{{siteDetail.latitude}}</div>
						</td>
						<td>每天应上传数据</td>
						<td>{{siteDetail.commSum}}</td>
					</tr>
				</tbody>
			</table>
			<table style="width: 100%;color:#fff">
				<tbody>
					<tr>
						<td style="border-top: none;">站点介绍</td>
						<td style="width: 44.5%;border-top: none;">
							<div style="text-indent: 2rem;height: 120px;overflow-y: scroll;display: flex;align-items: center;justify-content: center;padding: 5px;line-height: 23px;">{{siteDetail.remark?siteDetail.remark:'暂无介绍'}}</div>
						</td>
					</tr>
				</tbody>
			</table> -->
	<div class="site-tab">
		<div class="tab-item" v-for="(item,index) in tabList" :class="[selectIndex==item.id?'tab-item-selected':'']" @click="onTotab(item.id)">{{item.name}}</div>
	</div>
	<div class="site-content">
		<!-- 监测因子 -->
		<div class="site-factors" v-if="selectIndex===1">
			<!-- <a-table :pagination='false' style='text-align: center;' id="tb" ref="table" size="middle" bordered :scroll="scroll"
			 :columns="columns" :dataSource="dataSource"></a-table> -->
			 <file-list v-if="tableList.length>0" siteType='6' :columns='columns' :siteWarnList='tableList'></file-list>
			 <div v-else class="inner-img-none">该站点暂未配置监测因子</div>
		</div>
		<!-- 八位图 -->
		<div class="site-diagrams" v-if="selectIndex===2">
			<div v-for="(item,index) in imgList" :key='index' class="site-diagrams-item">
				<img :src="item.src" preview="4"/>
			</div>
		</div>
		<!-- 实景图 -->
		<div v-if="selectIndex===3">
			<el-carousel :interval="4000" arrow="hover" height="480px" class='site-interior' v-if="innerImglist.length>0">
				<el-carousel-item class="interior-item" v-for="(item,index) in innerImglist" :key="index">
					<img :src="item.src" class="interior-img" preview="3"/>
				</el-carousel-item>
			</el-carousel>
			<div v-else class="inner-img-none" style="color:#fff">该站点暂未配置内景图片</div>
		</div>
    <!-- 物联网卡-->
    <div class="site-factors" v-if="selectIndex===4">
        <network-card v-if="networkList.length>0"  :columns='networkColumns' :networkList='networkList'></network-card>
      <div v-else class="inner-img-none">该站点暂未配置物联网卡</div>
    </div>
		<!-- <a-carousel style="height: 450px;margin-top: 20px;" :autoplay="true" arrows class='site-interior' v-if="selectIndex==3">
				<div class="interior-item" v-for="item in 6">
					<img src="@/assets/others/index/direction.png" class="interior-img" />
				</div>
			</a-carousel> -->
	</div>
	</div>
</template>

<script>
	import {
		querySiteFactorById
	} from '@/api/api'
	import {
		getAction,
	} from '@/api/manage'
	import none from '@/assets/others/index/none.png'
	import direct from '@assets/others/index/site_picture.png'
	import fileList from '@/components/border/fileList'
  import networkCard from '@/components/border/networkCard'
	export default {
		components:{fileList,networkCard},
		props: {
			siteDetail: {
				default: {},
				type: Object
			},
			selectId: {
				default: '0',
				type: String
			},
		},
		watch: {
			selectId(val) {
				this.selectIndex = 1
				// 获取因子列表
				this.getFactor(val)
        this.getNetworkCard(val)
			},
			dataSource() {
				if (this.dataSource.length > 0) this.scroll = {
					y: 430
				}
				else this.scroll = {}
			}
		},
		data() {
			return {
				tableList:[],
        networkList: [],
				url: {
					imgServer: window._CONFIG['domianURL'] + '/sys/common/file/view',
				},
				columns: [
					{
						title: '监测因子',
						dataIndex: 'factorName',
						key: 'factorName',
						align: 'center',
						width: 150
					},
					{
						title: '编号',
						dataIndex: 'code',
						key: 'code',
						align: 'center',
						width: 150
					},
					{
						title: '限制类型',
						dataIndex: 'restrictionName',
						key: 'restrictionName',
						align: 'center',
						width: 150
					},
					{
						title: '最小值',
						dataIndex: 'lower',
						key: 'lower',
						align: 'center',
						width: 150
					},
					{
						title: '最大值',
						dataIndex: 'upper',
						key: 'upper',
						align: 'center',
						width: 150
					},
					{
						title: '单位',
						dataIndex: 'unitName',
						key: 'unitName',
						align: 'center',
						width: 150
					}
				],
        networkColumns: [
          {
            title: 'iccid',
            dataIndex: 'iccid',
            key: 'iccid',
            align: 'center',
            width: 150
          },
          {
            title: 'misidn',
            dataIndex: 'msisdn',
            key: 'msisdn',
            align: 'center',
            width: 150
          },
          {
            title: '密钥名称',
            dataIndex: 'name',
            key: 'name',
            align: 'center',
            width: 150
          },
          {
            title: '卡有效期',
            dataIndex: 'expiredAt',
            key: 'expiredAt',
            align: 'center',
            width: 150
          },
          {
            title: '卡状态',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            width: 150
          },
          {
            title: '已用流量(MB)',
            dataIndex: 'used',
            key: 'used',
            align: 'center',
            width: 150
          },
          {
            title: '剩余流量(MB)',
            dataIndex: 'surplus',
            key: 'surplus',
            align: 'center',
            width: 150
          },
          {
            title: '运营商',
            dataIndex: 'carrier',
            key: 'carrier',
            align: 'center',
            width: 150
          }
        ],
				scroll: {},
				dataSource: [
					// {
					//     key: '1',
					//     code: 'w01001',
					// 	title:'PH',
					// 	unitName:'mg/L',
					// 	upper:100,
					// 	lower:1
					//   },
					//   {
					//       key: '2',
					//       code: 'w01002',
					//   	title:'化学需氧量',
					//   	unitName:'mg/L',
					//   	upper:200,
					//   	lower:2
					//     },
				],
				tabList: [{
					name: '监测因子',
					id: 1
				}, {
					name: '八方位图',
					id: 2
				}, {
					name: '内景图',
					id: 3
				},{
				  name: '物联网卡',
          id: 4
      }],
				selectIndex: 1,
				imgList: [], //八位图列表
				innerImglist: [], //内景图列表
			}
		},
		methods: {
			// 获取内景图
			getInnerPic(id) {
				getAction(`/sys/common/file/queryFile/site_info_file/${id}`).then(res => {
					if (res.success && res.result.length > 0) {
						res.result.forEach((item, index) => {
							item.src = this.getImageView(item.id)
						})
						this.innerImglist = res.result
					} else {
						this.innerImglist = []
					}
				})
			},
			getImageView(photo) {
				return this.url.imgServer + '/' + photo
			},
			// 获取八位图
			getPic(id) {
				this.imgList = []
				getAction(`/site/picture/find/${id}`).then(res => {
					if (res.success) {
						this.imgList = [{
								src: res.result.northwest ? this.getImageView(res.result.northwest) : none
							}, {
								src: res.result.north ? this.getImageView(res.result.north) : none
							}, {
								src: res.result.northeast ? this.getImageView(res.result.northeast) : none
							}, {
								src: res.result.west ? this.getImageView(res.result.west) : none
							}, {
								src: direct
							},
							{
								src: res.result.east ? this.getImageView(res.result.east) : none
							}, {
								src: res.result.southwest ? this.getImageView(res.result.southwest) : none
							}, {
								src: res.result.south ? this.getImageView(res.result.south) : none
							}, {
								src: res.result.southeast ? this.getImageView(res.result.southeast) : none
							}
						]
						this.$previewRefresh();
					} else {
						for (let i = 0; i < 8; i++) {
							let obj = {}
							obj.src = none
							this.imgList.push(obj)
						}
						this.imgList.splice(4, 0, {
							src: direct
						})
						this.$previewRefresh();
					}
				})
			},
			// 获取因子列表
			getFactor(siteId) {
				getAction(`/site/info/factor/find/${siteId}`).then(res => {
					if (res.success) {
						this.tableList = res.result
						// this.dataSource = res.result
					}else{
						this.tableList = []
					}
				})
				// querySiteFactorById({
				// 	siteId,
				// 	pageNo: 1,
				// 	pageSize: 10000
				// }).then(res => {

				// })
			},
      //获取物联网卡列表
      getNetworkCard(siteId){
			  const param ={
			    scope: 1,
          scopeId: siteId,
          siteId: siteId
        }
			  getAction(`/site/iot/network/card`,param).then(res=>{
			    if(res.success){
			      if(res.result){
              this.networkList = res.result.records
            }else{
              this.networkList = []
            }
          }else{
			      this.networkList = []
          }
        })
      },
			onTotab(id) {
				if (this.selectIndex == id) return
				this.selectIndex = id
				switch (id) {
					case 1:
						this.getFactor(this.selectId)
						break;
					case 2:
						// 获取八位图
						this.getPic(this.selectId);
						break;
					case 3:
						// 获取内景图
						this.getInnerPic(this.selectId);
						break;
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;

		.none {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		// height: 950px;
		.site-info {
			margin-top: 10px;
			.site-info-border{
				height: 170px;
				width: 19%;
				border-radius: 10px;
				border: 2px solid #0c3784;
				text-align: center;
				box-shadow: 0 0 10px #0c3784;
				animation:name .9s linear;
				.site-info-content{
					width: 100%;
					height: 120px;
					color: #0ff;
					font-size: 1.4rem;
					// line-height: 15px;
					display: flex;
					align-items: center;
					justify-content: center;
					font-family: 'UnidreamLED';
					span{
						color: #0ff;
						margin-right: 5px;
						// font-size: 23px;
					}
				}
			}
			.site-info-border:nth-child(2),.site-info-border:nth-child(4){
				margin: 0 20px;
			}
			.site-info-item {
				width: 24%;
				height: 50px;
				border: 1px solid #199ed8;
				border-radius: 20px;
				display: flex;
				line-height: 50px;
				color: #fff;
				margin-right: 12px;

				.site-info-title {
					width: 35%;
					font-size: 15px;
					border-right: 1px solid #199ed8;
					background-color: #199ed8;
					text-align: center;
					border-top-left-radius: 20px;
					border-bottom-left-radius: 20px;
				}

				.site-info-num {
					text-align: center;
					width: 65%;
					font-size: 18px;
				}
			}

			.none {
				display: flex;
				justify-content: center;
				align-items: center;
			}

			tr {
				td {
					height: 50px;
					border: 1px solid #00f;
					line-height: 50px;
					text-align: center;
				}

				td:nth-child(2n+1) {
					width: 4%;
				}

				td:nth-child(2n) {
					width: 8%;
				}
			}
		}

		.site-tab {
			display: flex;
			color: #fff;
			font-size: 13px;
			margin-top: 10px;
			.tab-item {
				margin-right: 20px;
				cursor: pointer;
				background: url('../../../../../assets/others/index/tab-img.png') no-repeat;
				background-size: 100% 100%;
				padding: 5px 10px;
				width: 80px;
				text-align: center;
				user-select: none;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.tab-item-selected {
				// border: 1px solid #0ff;
				background: url('../../../../../assets/others/index/tab-img-select.png') no-repeat;
				background-size: 100% 100%;
				animation: width .5s linear;
				color: #142436 !important;
			}

			@keyframes width {
				from {
					background-size: 100% 0%;
				}

				to {
					background-size: 100% 100%;
				}
			}
		}

		.site-content {
			width: 100%;
			margin-top: 10px;

			.site-factors {
				animation:name .9s linear;
				max-height: 470px;
				// overflow: scroll;
				max-width: 100%;
				color: #fff !important;
				.inner-img-none {
					font-size: 50px;
					width: 100%;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-top: 10%;
					color: #000;
					// color: #15346b;
				}
			}

			/deep/.ant-table-header {
				background: none !important;
			}

			/deep/ .ant-table-tbody {
				color: #0ff;
			}

			/deep/ .ant-table-body {
				background: none !important;
			}

			/deep/.ant-table-thead>tr>th {
				background: rgba(0, 0, 0, 0);
				color: #ccc;
			}

			/deep/.ant-table-placeholder {
				background: none;
				color: #0ff;
			}

			// height: 100%;
			.site-diagrams {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				width: 25vw;
				margin-left: 35%;

				.site-diagrams-item {
					width: 8vw;
					height: 8vw;
					margin-top: 10px;
					border-radius: 10px;
					display: flex;
					align-items: center;
					justify-content: center;

					img {
						width: 100%;
						// height: auto !important;
						height: 100%;
						border-radius: 10px;
						cursor: pointer;
						// background-color: #fff;
					}

					// img:hover {
					// 	// width: 245px;
					// 	height: auto !important;
					// 	transform: scale(1.1);
					// 	transition: .5s ease-out;
					// 	// animation: border .5s linear;
					// }

					@keyframes border {
						from {
							width: 145px;
						}

						to {
							width: 245px;
						}
					}
				}

				.site-diagrams-item:nth-child(5) {
					background-color: #fff;

					// img:hover{
					// 	transform: scale(1)
					// }
				}

				img:nth-child(3n-1) {
					margin: 0 10px;
					margin-top: 10px;
				}
			}

			.site-interior {

				// width: 100%;
				.interior-item {
					width: 100%;
					display: flex !important;
					justify-content: center;
					cursor: pointer;
					.interior-img {
						height: 450px;
						width: auto !important;
					}
				}
			}

			.inner-img-none {
				font-size: 50px;
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-top: 10%;
				// color: #15346b;
			}
		}

		::-webkit-scrollbar {
			display: none;
			/* Chrome Safari */
		}
	}
</style>
